import { UserProfileAttributeVisualizerComponent } from "../../components/shared/user-profile-attribute-visualizer/user-profile-attribute-visualizer.component";
import { BaseEntityAttribute } from "./base-entity-attribute";

export class UserProfileAttribute {
  constructor(public mapEntityId: string, public entity: any) {}

  getVisualizer() {
    return {
      component: UserProfileAttributeVisualizerComponent,
      inputs: { entity: this.entity }
    };
  }
}